import { agencyPath, createRequestWithComputedFilters } from '@/utils/api'
import network from '@/utils/network'

/**
 * Récupère les contrats agents
 * @param filters
 * @param opt
 * @returns {Promise}
 */
export const fetchAgencyAgentContracts = createRequestWithComputedFilters(
  async (params) => {
    const r = await network.post(`${agencyPath()}/fetch/contracts/agents`, params)
    return r.data
  }, {
    orderBy: 'createdAt',
    filters: {
      status: [],
      end: '',
      start: ''
    }
  })

/**
 * Récupère le base64 d'un contrat agent
 * @returns {Promise<>}
 */
export const getAgencyAgentContractPdf = async (agentContract) => {
  const r = await network.post(`${agencyPath()}/contract/agent/preview`, agentContract)
  return r.data
}

/**
 * Créé / met à jour un contrat agent
 * @returns {Promise<>}
 */
export const postAgencyAgentContract = async (agentContract) => {
  const r = await network.post(`${agencyPath()}/contract/agent`, agentContract)
  return r.data
}

/**
 * Récupère un contrat agent
 * @returns {Promise<>}
 */
export const getAgencyAgentContract = async (id) => {
  const r = await network.get(`${agencyPath()}/contract/agent/${id}`)
  return r.data.contract
}

/**
 * Créé / met à jour le token de signature d'un contrat agent
 * @returns {Promise<>}
 */
export const postAgencyAgentContractSigningToken = async (agentContract) => {
  const r = await network.post(`${agencyPath()}/contract/agent/signature`, agentContract)
  return r.data
}

/**
 * Envoie par courrier un contrat agent
 * @returns {Promise<>}
 */
export const sendAgencyAgentContract = async (agentContract) => {
  const r = await network.post(`${agencyPath()}/agent/contract/send`, agentContract)
  return r.data
}

/**
 * Supprime un  contrat agent
 * @returns {Promise<>}
 */
export const deleteAgencyAgentContract = async (id) => {
  const r = await network.delete(`${agencyPath()}/contract/agent/${id}`)
  return r.data
}
